import {
  ORDER_CREATE_FAIL,
  ORDER_CREATE_REQUEST,
  ORDER_CREATE_SUCCESS,
  ORDER_DETAILS_FAIL,
  ORDER_DETAILS_REQUEST,
  ORDER_DETAILS_SUCCESS,
  ORDER_PAY_RESET,
  ORDER_PAY_REQUEST,
  ORDER_PAY_SUCCESS,
  ORDER_PAY_FAIL,
  ORDER_LIST_MY_RESET,
  ORDER_LIST_MY_REQUEST,
  ORDER_LIST_MY_SUCCESS,
  ORDER_LIST_MY_FAIL,
  ORDER_LIST_RESET,
  ORDER_LIST_REQUEST,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_FAIL,
  ORDER_DELIVER_RESET,
  ORDER_DELIVER_REQUEST,
  ORDER_DELIVER_SUCCESS,
  ORDER_DELIVER_FAIL,
  ORDER_EDIT_REQUEST,
  ORDER_EDIT_SUCCESS,
  ORDER_EDIT_FAIL,
  ORDER_EDIT_RESET,
} from "../constants/orderConstants";

export const orderCreateReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_CREATE_REQUEST: //orderCreateRequest
      return {
        loading: true,
      };
    case ORDER_CREATE_SUCCESS: //orderCreateSuccess
      return {
        loading: false,
        success: true,
        order: action.payload,
      };
    case ORDER_CREATE_FAIL: //orderCreateFail
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const orderDetailsReducer = (
  state = { loading: true, orderItems: [], shippingAddress: {} },
  action
) => {
  switch (action.type) {
    case ORDER_DETAILS_REQUEST: //orderDETAILSRequest
      return {
        ...state,
        loading: true,
      };
    case ORDER_DETAILS_SUCCESS: //orderDETAILSSuccess
      return {
        loading: false,
        order: action.payload,
      };
    case ORDER_DETAILS_FAIL: //orderDETAILSFail
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export const orderPayReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_PAY_REQUEST: //orderPayRequest
      return {
        loading: true,
      };
    case ORDER_PAY_SUCCESS: //orderPaySuccess
      return {
        loading: false,
        success: true,
      };
    case ORDER_PAY_FAIL: //orderPayFail
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_PAY_RESET: //orderPayReset
      return {};
    default:
      return state;
  }
};

export const orderListMyReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case ORDER_LIST_MY_REQUEST: //orderListMyRequest
      return {
        loading: true,
      };
    case ORDER_LIST_MY_SUCCESS: //orderListMySuccess
      return {
        loading: false,
        orders: action.payload.orders,
        orderPages: action.payload.orderPages,
        page: action.payload.page,
      };
    case ORDER_LIST_MY_FAIL: //orderListMyFail
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_LIST_MY_RESET: //orderListMyReset
      return { orders: [] };
    default:
      return state;
  }
};

export const orderListReducer = (state = { orders: [] }, action) => {
  switch (action.type) {
    case ORDER_LIST_REQUEST: //orderListRequest
      return {
        loading: true,
      };
    case ORDER_LIST_SUCCESS: //orderListSuccess
      return {
        loading: false,
        orders: action.payload.orders,
        orderPages: action.payload.orderPages,
        page: action.payload.page,
        paidValue: action.payload.paidValue,
        deliveredValue: action.payload.deliveredValue,
      };
    case ORDER_LIST_FAIL: //orderListFail
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_LIST_RESET: //orderListReset
      return { orders: [] };
    default:
      return state;
  }
};

export const orderEditReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_EDIT_REQUEST:
      return { loading: true };
    case ORDER_EDIT_SUCCESS:
      return { loading: false, success: true, order: action.payload };
    case ORDER_EDIT_FAIL:
      return { loading: false, error: action.payload };
    case ORDER_EDIT_RESET:
      return {};
    default:
      return state;
  }
};

export const orderDeliverReducer = (state = {}, action) => {
  switch (action.type) {
    case ORDER_DELIVER_REQUEST: //orderDeliverRequest
      return {
        loading: true,
      };
    case ORDER_DELIVER_SUCCESS: //orderDeliverSuccess
      return {
        loading: false,
        success: true,
      };
    case ORDER_DELIVER_FAIL: //orderDeliverFail
      return {
        loading: false,
        error: action.payload,
      };
    case ORDER_DELIVER_RESET: //orderDeliverReset
      return {};
    default:
      return state;
  }
};
